<script lang="ts">
    import MedialibFile from "../../../widgets/MedialibFile.svelte"
    import MedialibImage from "../../../widgets/MedialibImage.svelte"

    let { block }: { block: DownloadablePreviewCardBlock } = $props()
</script>

<div class="image-download">
    <div class="img">
        <MedialibImage id={block.content.preview_image[0]} maxWidth={300} />
    </div>
    <div class="content">
        <div>
            <bold>{block.content.title_preview_card}</bold>
            <small>{block.content.description}</small>
        </div>
        <MedialibFile id={block.content.file[0]} let:src>
            <a href={src} download target="_blank">
                <span>Download</span>
                <img src="/media/download-icon.svg" alt="download" />
            </a>
        </MedialibFile>
    </div>
</div>

<style lang="less" global>
    .image-download {
        display: flex;
        height: 152px;
        width: 100%;
        overflow: hidden;
        border-radius: 4px;
        background: var(--bg-200);
        .img {
            border-radius: 4px;
            min-width: 152px;
            min-height: 152px;
            width: 152px;
            height: 152px;
            position: relative;
            &::before {
                content: "";
                height: 100%;
                width: 100%;
                position: absolute;
                top: 0px;
                left: 0px;
                border-radius: 4px;
                background: radial-gradient(50% 50% at 50% 50%, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.2) 100%);
            }
            img {
                height: 100%;
                width: 100%;
                object-fit: cover;
                object-position: center center;
                border-radius: 4px;
            }
        }
        .content {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 1.2rem;
            width: 100%;
            div {
                display: flex;
                flex-direction: column;
                gap: 0.3rem;
                bold {
                    font-size: 0.7rem;
                    font-weight: 700;
                    text-transform: uppercase;
                }
                small {
                    font-size: 0.7rem;
                }
            }
            a {
                span {
                    text-transform: uppercase;
                    font-size: 0.7rem;
                    transition: padding-left 0.3s ease-in-out;
                }
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                img {
                    height: 1.2rem;
                }
                &:hover {
                    span {
                        padding-left: 0.3rem;
                    }
                }
            }
        }
    }
</style>
